import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustSignals from '../components/TrustSignals';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import Regulations from '../components/Regulations';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import EligibilityChecker from '../components/EligibilityChecker';

const HomePage = () => {
  const [isCheckerOpen, setIsCheckerOpen] = useState(false);

  const handleCheckFlight = () => {
    setIsCheckerOpen(true);
  };

  return (
    <div>
      <Header onCheckFlight={handleCheckFlight} />
      <Hero onCheckFlight={handleCheckFlight} />
      <TrustSignals />
      <HowItWorks />
      <Benefits />
      <Regulations />
      <Testimonials />
      <FAQ />
      <CTA onCheckFlight={handleCheckFlight} />
      <Footer />
      
      <EligibilityChecker 
        isOpen={isCheckerOpen} 
        onClose={() => setIsCheckerOpen(false)} 
      />
    </div>
  );
};

export default HomePage;
